// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wizard":"wizard__wizard--29cbE","item":"wizard__item--3hngo","active":"wizard__active--3q7qO"};